import { Reducer } from "redux";
import ActionTypes from "../../../constants";
import { actionChannel } from "redux-saga/effects";
import { NotificationType } from "../types";
import { PaginationInfoType } from "../../BusinessPartnerLists/types";

interface NotificationState {
  notifications: NotificationType | null;
  pageInfo: PaginationInfoType | null,
  notificationUpdated: boolean;
}

const initialState = {
  notifications: null,
  pageInfo: null,
  notificationUpdated: false
};

const notification = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_NOTIFICATION_SUCCEEDED: {
      const notifications = action.notifications;
      const pageInfo = action.pageInfo;
      return { ...state, notifications, pageInfo };
    }
    case ActionTypes.UPDATE_NOTIFICATION_SUCCEEDED: {
      const bpId = action.payload.bpId;
      const notifications = state.notifications.filter(
        item => item.bpId !== bpId
      );
      return { ...state, notifications, notificationUpdated: true };
    }
    case ActionTypes.RESET_NOTIFICATION_UPDATED_FLAG: {
      return { ...state, notificationUpdated: false };
    }
    default: {
      return state;
    }
  }
};

export default notification;
